// @mui
import {
  Card,
  Container,
  MenuItem,
  Select,
  Stack,
  Table,
  TableContainer,
  Typography
} from '@mui/material';
// components
import Scrollbar from '@src/components/scrollbar';
// mock
import DataTableRow from '@src/components/data-table/data-row';
import { TABLE_HEAD_LASTWEEK_DRAW_RESULT } from '@src/utils/mockdata/table-headers';
import moment from 'moment';
import { useState } from 'react';
import { useServices } from '../hooks';
import TableHeader from './table-header';
import TableRowItem from './table-row';

function LastweekDraw() {
  return (
    <Body />
  );
}

const Body = () => {
  const { raffleResult, isLoading } = useServices();
  const [selectedIndex, setSelectedIndex] = useState(1);

  const lastweekDraw = raffleResult[selectedIndex] ?? {};

  return (
    <Container disableGutters sx={{ mt: 7 }}>
      <Stack mt={4} direction={"row"} justifyContent={"space-between"} alignItems={"center"} width={"auto"}>
        <Typography display={"inline"} color={"#333B69"} fontSize={19} fontWeight={700}>
          Last Week Draw Results
        </Typography>
        <Typography display={"inline"} color={"#333B69"} fontSize={19} fontWeight={700}>
          Description: <Typography component={"span"} color="#718EBF" fontSize={19}
          fontWeight={700}>{lastweekDraw?.raffle?.description}</Typography>
        </Typography>
      </Stack>
      <Stack mt={2} direction={"row"} justifyContent={"space-between"} alignItems={"center"} width={"auto"}>
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          <Typography color="#333B69" fontSize={19} fontWeight={700}>Draw Number:</Typography>
          <Select
            value={selectedIndex}
            onChange={(e) => setSelectedIndex(Number(e.target.value))}
            size="small"
            sx={{
              fontSize: 15,
              fontWeight: 700,
              color: "#718EBF",
              minWidth: 130,
              ".MuiOutlinedInput-notchedOutline": { borderColor: "#718EBF" },
            }}
          >
            {raffleResult.map((item: any, i: number) => (
              <MenuItem key={i} value={i}>
                {item?.raffle?.code}
              </MenuItem>
            ))}
          </Select>
        </Stack>
        <Typography display={"inline"} color={"#333B69"} fontSize={19} fontWeight={700}>
          Draw Date: <Typography component={"span"} color="#718EBF" fontSize={19}
          fontWeight={700}>{moment(lastweekDraw?.raffle?.drawAt).format("MM / DD / YYYY")}</Typography>
        </Typography>
      </Stack>
      <Card sx={{mt: 2, p: 2}}>
        <Scrollbar>
          <TableContainer>
            <Table>
              <TableHeader
                disableButton
                headLabel={TABLE_HEAD_LASTWEEK_DRAW_RESULT}
              />
              <DataTableRow
                colSpan={7}
                isLoading={isLoading}
                headers={TABLE_HEAD_LASTWEEK_DRAW_RESULT}
                data={lastweekDraw.winners || []}
                renderItem={({ item, index }: any) => {
                  return <TableRowItem
                    key={`${index}`} {...item}
                  />
                }} />
            </Table>
          </TableContainer>
        </Scrollbar>
      </Card>
    </Container>
  );
}

export default LastweekDraw;
